import CollapsibleDetailView from "@components/molecules/CollapsibleDetailView";
import PriceDetailView from "@components/molecules/PriceDetailView";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useState } from "react";
import { Platform, View } from "react-native";
import styled, { useTheme } from "styled-components/native";
import { MatchPriceDescriptionViewProps } from "./types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { VDBIcons } from "@utils/VDBIcons";
import { css } from "styled-components/native";
import { matchPairConatinerWidth } from "@scenes/findMatch/utils";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import React from "react";
import { ProductCategory } from "@utils/constants";
import { productLevelOneColor } from "@utils/product/productTheme";

const MatchPriceDescriptionView = ({
  itemDetail,
  otherDetail,
  currentIndex,
  priceMode,
  productType,
}: MatchPriceDescriptionViewProps) => {
  const theme = useTheme();

  const [expandLeftView, setExpandLeftView] = useState(false);
  const [expandRightView, setExpandRightView] = useState(false);
  const typography = useTypographyStore();

  const RenderDetailComponent = ({ isPrimary }: { isPrimary: boolean }) => {
    return (
      <PriceDetailContainer>
        <PriceDetailView
          itemDetail={isPrimary ? itemDetail : otherDetail?.[currentIndex]}
          priceMode={priceMode}
          productType={productType}
          fromMatchPair={true}
        />
        {(isPrimary
          ? itemDetail?.pricing_comment
          : otherDetail?.[currentIndex]?.pricing_comment) &&
          priceMode !== PriceModes.ORANGE && (
            <>
              <Divider />
              <LabelContainer>
                <VDBIcon
                  color={
                    theme[productLevelOneColor(productType as ProductCategory)]
                  }
                  size={24}
                  variant={IconsVariant.VDBCustom}
                  name={VDBIcons.PRICE_COMMENT}
                />
                <VDBText
                  type={typography["Body-R"]}
                  color={theme["core-06"]}
                  numberOfLines={
                    (isPrimary ? expandLeftView : expandRightView)
                      ? undefined
                      : 1
                  }
                  ellipsizeMode="tail"
                >
                  {itemDetail?.pricing_comment}
                </VDBText>
                {/* <LabelView
                leftIcon={VDBIcons.PRICE_COMMENT}
                leftIconTheme={theme["diam-06"]}
                ellipsize={expandView ? false : true}
                valueTypographyStyle={typography["Body-R"]}
                itemRightText={
                  isPrimary
                    ? itemDetail?.pricing_comment
                    : otherDetail?.[currentIndex]?.pricing_comment
                }
                rightPrefixTextTheme={theme["core-06"]}
              /> */}
              </LabelContainer>
            </>
          )}
      </PriceDetailContainer>
    );
  };

  return (
    <PriceDetailContainer>
      <FlexMainView>
        <MainContainerView testID="findMatch.priceDescription.primary">
          <LeftLabelContainer keyMargin={20}>
            {itemDetail?.pricing_comment && priceMode !== PriceModes.ORANGE ? (
              <CollapsibleDetailView
                expandView={expandLeftView}
                setExpandView={setExpandLeftView}
                initExpanded={expandLeftView}
                title={RenderDetailComponent({ isPrimary: true })}
                forceExpand={true}
              >
                <View>{/* Additional content if needed */}</View>
              </CollapsibleDetailView>
            ) : (
              <PriceViewContainer>
                <RenderDetailComponent isPrimary={true} />
              </PriceViewContainer>
            )}
          </LeftLabelContainer>
        </MainContainerView>
        <GapView />
        <MainContainerView testID="findMatch.priceDescription.secondary">
          <LeftLabelContainer keyMargin={20}>
            {otherDetail?.[currentIndex]?.pricing_comment &&
            priceMode !== PriceModes.ORANGE ? (
              <CollapsibleDetailView
                expandView={expandRightView}
                setExpandView={setExpandRightView}
                initExpanded={expandRightView}
                title={RenderDetailComponent({ isPrimary: false })}
                forceExpand={true}
              >
                <View>{/* Additional content if needed */}</View>
              </CollapsibleDetailView>
            ) : (
              <PriceViewContainer>
                <RenderDetailComponent isPrimary={false} />
              </PriceViewContainer>
            )}
          </LeftLabelContainer>
        </MainContainerView>
      </FlexMainView>
    </PriceDetailContainer>
  );
};

const PriceDetailContainer = styled.View`
  flex-direction: column;
`;

const MainContainerView = styled.View<any>`
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  ${({ theme }) => matchPairConatinerWidth(theme)}
`;

const FlexMainView = styled.View<any>`
  flex-direction: row;
  justify-content: space-between;
`;

const LeftLabelContainer = styled.View<any>`
  margin: ${({ keyMargin }) => `10px ${keyMargin}px`};
`;

const Divider = styled.View`
  height: 1px;
  flex-direction: row;
  background-color: ${({ theme }) => theme["core-03"]};
  width: 100%;
  maxwidth: 100%;
`;

const LabelContainer = styled.View<any>`
  padding-top: 10px;
  padding-bottom: 3px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: ${SpaceType.Small}px;
  margin-right: ${({ theme }) => (theme.isMobile ? 0 : 20)}px;
`;

const PriceViewContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  align-content: flex-start;
  border-radius: 8px;
  margin-vertical: 5px;
  padding-top: 5px;
  border-width: 1px;
`;

const GapView = styled.View`
  ${({ theme }) =>
    Platform.OS === "web" &&
    !theme.isMobile &&
    css`
      width: 30px;
    `}
`;

export default MatchPriceDescriptionView;
